module.exports = __webpack_public_path__ + "static/header-video-e5d27aa474fe21f82cce8ad8f7637faa.webm";